import { orderBy } from 'lodash';
import { noResultsText } from 'utils/charts/constants';

export const landingTopThreeTeamsOptions = (data) => {
    const sortedData = data && orderBy(data, ['score'], ['asc']);
    return {
        title: {
            text: 'Top 3 Teams - By Team Risk Score',
            textStyle: {
                color: '#244B60',
                fontSize: '12px'
            },
            top: 0,
            left: 10
        },
        grid: {
            containLabel: true,
            width: '570px',
            height: '40%',
            left: '15%',
            top: 'center'
        },
        xAxis: {
            name: 'Team Risk Score',
            nameLocation: 'middle',
            nameTextStyle: {
                color: '#7FADBF',
                fontSize: '12',
                fontWeight: 600
            },
            nameGap: 60,
            type: 'value',
            axisTick: false,
            axisLine: false,
            axisLabel: false,
            splitLine: { show: false }
        },
        yAxis: {
            type: 'category',
            data: sortedData
                ? sortedData.slice(-3).map((team) => team.dimension)
                : [],
            axisTick: false,
            boundaryGap: false,
            axisLine:
                sortedData && sortedData.length > 0
                    ? {
                          lineStyle: {
                              color: '#E7E7E7'
                          }
                      }
                    : { show: false },
            axisLabel: {
                color: '#929292',
                fontSize: '12px',
                fontWeight: 400
            }
        },
        series: [
            {
                name: 'Top 3 Teams',
                type: 'bar',
                stack: 'total',
                label: {
                    show: true,
                    position: 'right',
                    color: '#929292',
                    distance: 12
                },
                itemStyle: {
                    color: '#9BCEE2'
                },
                emphasis: {
                    focus: 'self',
                    blurScope: 'series'
                },
                barWidth: 35,
                data: sortedData
                    ? sortedData.slice(-3).map((team) => team.score)
                    : []
            }
        ],
        graphic: !sortedData || sortedData.length === 0 ? [noResultsText] : []
    };
};
